import { createSelector, createSlice } from "@reduxjs/toolkit";
import { fetchCases } from "./Thunks";
import { Case } from "../../../api/cases";
import { RootState } from "@/src/app/store";
import { ParticipantType } from "../../../api/participants";

interface CaseListState {
    cases: Case[];
    status: "idle" | "loading" | "error"
}

const initialState: CaseListState = {
    cases: [],
    status: "idle"
}

const caseListSlice = createSlice({
    name: 'caseList',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchCases.pending, (state) => {
            state.status = "loading"
        })
        builder.addCase(fetchCases.fulfilled, (state, action) => {
            state.cases = action.payload.cases
            state.status = "idle"
        })
        builder.addCase(fetchCases.rejected, (state, action) => {
            if(!action.meta.aborted)
                state.status = "error"
        })
    }
})

export const getCases = (state: RootState) => (state.caseList.cases)
export const getCaseListStatus = (state: RootState) => (state.caseList.status)

export const getCaseDealingOfficerIds = createSelector([getCases], (cases) =>
    Array.from(
        new Set(
            cases
                .map(
                    (c) =>
                        c.participations?.find(
                            (p) => p.participant_type === ParticipantType.CASE_DEALING_OFFICER
                        )?.participant_id
                )
                .filter((id): id is string => Boolean(id))
        )
    )
)

export const caseListReducer = caseListSlice.reducer;